import React from 'react';
import { Box } from '@mui/material';
import { ModuleCard } from 'components/shared';
import monitoringUser from '../../assets/icons/monitoring_icon_blue.svg';
import { ROUTES } from 'routes/constants';
import ContainerPainel from 'components/container_painel';

const MenuService: React.FC = () => {
  return (
    <ContainerPainel
      pagina='Gestão de Serviços'
      showBackButton={true}
      backButtonPath={ROUTES.HOME}
    >
      <Box
        sx={{
          height: '65px',
          backgroundColor: '#0048B6',
          alignContent: 'center',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#0048B6',
            height: '67px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginTop: '25px',
            alignItems: 'center',

          }}
        >
          <Box
            sx={{
              backgroundColor: '#FFFFFF',
              width: '90%',
              maxWidth: '1152px',
              alignItems: 'center',
              borderRadius: '10px',
              marginTop: '16px',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
              gap: '15px',
            }}
          >
            <ModuleCard
              title='CIFA - Cadastro do Índice Municipal de Agricultura Familiar'
              description='Gerencie todos os dados sobre o Cadastro do Índice Municipal de Agricultura Familiar disponíveis no sistema.'
              image={monitoringUser}
              path={ROUTES.MANAGE_CIFA}
            />
          </Box>
        </Box>
      </Box>
    </ContainerPainel>
  );
};

export default MenuService;
